import {
  CreateDataByIndexedDB,
  GetAllDataByIndexedDB,
} from '../../indexed/index';
import { getStandardTypeFilterValue } from '../../enums/labels/getStandardTypeFilterValue';
import { userHotelDetails } from '../../helpers/handleBrandAndHotelData';
import axiosInstance from '../../helpers/interceptor';

export const standard = async (
  categoryId,
  fromDate,
  isSelf,
  assessmentId,
  standardType,
  performanceClassification
) => {
  const { selectedHotel } = userHotelDetails();

  let view = `view=category`;

  if (performanceClassification && performanceClassification !== 'all') {
    view = `view=performance&performanceClassification=${performanceClassification}`;
  }

  let dataD: any = [];
  const OfflineData = await GetAllDataByIndexedDB(
    `${Env.API_URL}/customer/hotel-assessment-summary/${selectedHotel}/standards?&standard=${[1, 2, 3, '1', '2', '3'].includes(standardType) ? getStandardTypeFilterValue(standardType) : 'LQA'}&${view}&hotelId=${selectedHotel}&isDisplayOnly=0&visit=1${isSelf ? '&assessmentId=' + assessmentId : '&toDate=' + fromDate}&categoryId=${categoryId}${isSelf ? '&self=1&isClientApp=true' : ''}`,
    selectedHotel
  );
  if (OfflineData) {
    dataD = OfflineData;
  } else {
    const { data } = await axiosInstance.get(
      `${Env.API_URL}/customer/hotel-assessment-summary/${selectedHotel}/standards?&standard=${[1, 2, 3, '1', '2', '3'].includes(standardType) ? getStandardTypeFilterValue(standardType) : 'LQA'}&${view}&hotelId=${selectedHotel}&isDisplayOnly=0&visit=1${isSelf ? '&assessmentId=' + assessmentId : '&toDate=' + fromDate}&categoryId=${categoryId}${isSelf ? '&self=1&isClientApp=true' : ''}`
    );

    CreateDataByIndexedDB(
      `${Env.API_URL}/customer/hotel-assessment-summary/${selectedHotel}/standards?&standard=${[1, 2, 3, '1', '2', '3'].includes(standardType) ? getStandardTypeFilterValue(standardType) : 'LQA'}&${view}&hotelId=${selectedHotel}&isDisplayOnly=0&visit=1${isSelf ? '&assessmentId=' + assessmentId : '&toDate=' + fromDate}&categoryId=${categoryId}${isSelf ? '&self=1&isClientApp=true' : ''}`,
      data,
      selectedHotel
    );
    dataD = data;
  }
  return dataD;
};
